import React from "react";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  section: {
    backgroundColor: "#ffebee",
    padding: theme.spacing(5, 0),
    marginTop: theme.spacing(4),
    position: "relative",
    width: "100vw",
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
  },
  heading: {
    marginBottom: theme.spacing(0.5),
  },
  subheading: {
    marginBottom: theme.spacing(3),
  },
  media: {
    height: 180,
    backgroundColor: "#fff",
    objectFit: "contain",
  },
}));

const ImageGallery = ({ items }) => {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <Container maxWidth="md">
        <Typography variant="h4" component="h3" className={classes.heading}>
          Imágenes de muestra
        </Typography>
        <Typography variant="body2" color="textSecondary" className={classes.subheading}>
          Imágenes tomadas de nuestra interfaz de usuario con un evento demo
        </Typography>
        <Grid container spacing={2}>
          {items.map(({ imagen, titulo, detalle }) => (
            <Grid item xs={12} sm={6} md={4} key={titulo}>
              <Card>
                <CardMedia
                  component="img"
                  image={imagen}
                  alt={titulo}
                  className={classes.media}
                />
                <CardContent>
                  <Typography variant="subtitle1" gutterBottom>
                    {titulo}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {detalle}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
};

export default ImageGallery;
